import React from 'react';
import classNames from 'classnames';
import { IP3Props } from './P3.types';
import styles from './P3.module.css';

export const P3: React.FC<IP3Props> = ({ children, className }: IP3Props) => {
  return <p className={classNames(styles.p3, className)}>{children}</p>;
};
